import { FormEvent, useState } from 'react'
import { Trans, useTranslation } from 'react-i18next'

import lockIcon from '~/assets/images/communication/lock.svg'
import mailIcon from '~/assets/images/communication/mail.svg'
import { Styles as S } from '~/pages/communication/email/libs/components/EmailCommunication/styles'
import AutoComplete from '~/pages/email/lib/components/AutoComplete'
import { useEmail } from '~/pages/email/lib/hooks/useEmail'
import { Modal } from '~/shared/components/Modal'
import { Spinner } from '~/shared/components/Spinner'

const EmailCommunication = () => {
  const { t } = useTranslation()
  const [isNewsletterChecked, setIsNewsletterChecked] = useState(true)

  const {
    areEmailTipsVisible,
    isErrorModalShown,
    isButtonDisabled,
    isStatusFetching,
    inputValue,
    isValidInputValue,
    filteredEmailDomains,
    handleSubmit,
    handleChange,
    handleCloseErrorModal,
    handlePrefilledEmail,
  } = useEmail()

  if (isStatusFetching) return <Spinner />

  return (
    <>
      <S.Root>
        <S.StyledContainer>
          <S.StyledForm
            onSubmit={(e: FormEvent<HTMLFormElement>) => handleSubmit(e)}
          >
            <S.TitleGroup>
              <S.Title>
                <Trans i18nKey="email.title" />
              </S.Title>

              <S.Subtitle>
                <Trans i18nKey="email.subtitle" />
              </S.Subtitle>
            </S.TitleGroup>

            <S.EmailFieldWrapper
              data-valid={isValidInputValue}
              data-validation-text={t`email.error`}
            >
              <S.EmailInputInner>
                <S.MailIconWrapper>
                  <img src={mailIcon} alt="mail" width={24} height={24} />
                </S.MailIconWrapper>
                <S.EmailInput
                  type="email"
                  value={inputValue}
                  placeholder={t`email.placeholder`}
                  autoComplete="off"
                  onChange={handleChange}
                  required
                />
              </S.EmailInputInner>

              {areEmailTipsVisible && !!filteredEmailDomains.length && (
                <AutoComplete
                  domains={filteredEmailDomains}
                  handlePrefilledEmail={handlePrefilledEmail}
                />
              )}
            </S.EmailFieldWrapper>

            <S.PrivacyRow>
              <S.LockIcon>
                <img src={lockIcon} alt="lock" width={20} height={20} />
              </S.LockIcon>
              <S.PrivacyText>
                <Trans i18nKey="email.privacyText" />
              </S.PrivacyText>
            </S.PrivacyRow>

            <S.CheckboxRow onClick={() => setIsNewsletterChecked((v) => !v)}>
              <S.CheckboxContainer>
                <S.Checkbox $checked={isNewsletterChecked}>
                  {isNewsletterChecked && (
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="8"
                      height="6"
                      viewBox="0 0 8 6"
                      fill="none"
                    >
                      <path
                        d="M0.740234 2.22135L2.96153 4.44265L6.6637 0.740479"
                        stroke="#096EF9"
                        strokeWidth="1.48087"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                  )}
                </S.Checkbox>
              </S.CheckboxContainer>
              <S.CheckboxLabel>
                <Trans i18nKey="email.newsletterConsent" />
              </S.CheckboxLabel>
            </S.CheckboxRow>

            <S.StyledButton type="submit" disabled={isButtonDisabled}>
              <Trans i18nKey="actions.continue" />
            </S.StyledButton>
          </S.StyledForm>
        </S.StyledContainer>
      </S.Root>

      <Modal onClose={handleCloseErrorModal} isShown={isErrorModalShown}>
        {/* error message handled by parent Modal */}
      </Modal>
    </>
  )
}

export default EmailCommunication
